import { ClickEvent } from "@mcleod/components";
import { ShareOrder } from ".././ShareOrder";
import { LtlUtil } from "./LtlUtil";
import { AutogenLayoutBillOfLadingPanel } from "./autogen/AutogenLayoutBillOfLadingPanel";

export class BillOfLadingPanel extends AutogenLayoutBillOfLadingPanel {
    private _orderId: string | ((args?: any) => string);

    private getOrderId(): string {
        return this._orderId instanceof Function ? this._orderId() : this._orderId;
    }

    public set orderId(value: string) {
        this._orderId = value;
        this.labelOrderId.text = value;
    }

    public set hasShippingLabel(value: boolean) {
        this.buttonShippingLabel.visible = value === true;
    }

    buttonShareOnClick(event: ClickEvent) {
        ShareOrder.onClick(event, this.getOrderId());
    }

    buttonBOLOnClick(event: ClickEvent) {
        LtlUtil.downloadBOL(this.getOrderId());
    }

    buttonShippingLabelOnClick(event: ClickEvent) {
        LtlUtil.downloadApiShippingLabel(this.getOrderId());
    }
}
